import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Component to display bilingual text
 * Always shows English first, with translation below when language is set to 'ta'
 */
const BilingualText = ({ translationKey, className = '', style = {}, transClassName = '' }) => {
    const { t, i18n } = useTranslation();
    
    // Always get English text
    const englishText = t(translationKey, { lng: 'en' });
    
    // Always show Tamil translation (when available) beneath English
    const translatedText = t(translationKey, { lng: 'ta' });
    const showTranslation = i18n.language === 'ta';
    return (
        <div className={className} style={style}>
            <div className="fw-semibold text-dark d-inline">{englishText}</div>
            {showTranslation && translatedText && englishText !== translatedText && (
                <div className={`${transClassName} text-muted small`} style={{ fontSize: '11px', marginTop: '2px' }}>
                    {translatedText}
                </div>
            )}
        </div>
    );
};

/**
 * Inline bilingual text for labels
 */
export const BilingualLabel = ({ translationKey, required = false, className = '' }) => {
    const { t, i18n } = useTranslation();
    
    const englishText = t(translationKey, { lng: 'en' });
    const translatedText = t(translationKey, { lng: 'ta' });
    const showTranslation = i18n.language === 'ta';
    
    return (
        <span className={className}>
            {englishText}
           
            {showTranslation && translatedText && englishText !== translatedText && (
                <>
                    <small className="text-trans-muted fw-normal"> ({translatedText})</small>
                </>
            )}
             {required && <span className="text-danger"> *</span>}
        </span>
    );
};

/**
 * Get bilingual placeholder text
 */
export const useBilingualPlaceholder = (translationKey) => {
    const { t, i18n } = useTranslation();
    
    const englishText = t(translationKey, { lng: 'en' });
    const showTranslation = i18n.language === 'ta';
    
    if (showTranslation) {
        const translatedText = t(translationKey, { lng: 'ta' });
        if (englishText !== translatedText) {
            return `${englishText} (${translatedText})`;
        }
    }
    
    return englishText;
};

/**
 * Column header with bilingual support
 */
export const BilingualColumnHeader = ({ translationKey }) => {
    const { t, i18n } = useTranslation();
    
    const englishText = t(translationKey, { lng: 'en' });
    const translatedText = t(translationKey, { lng: 'ta' });
    const showTranslation = i18n.language === 'ta';

    return (
        <div>
            <div>{englishText}</div>
            {showTranslation && translatedText && englishText !== translatedText && (
                <small className='text-muted fw-normal d-block' style={{ fontSize: '10px' }}>
                    {translatedText}
                </small>
            )}
        </div>
    );
};

export default BilingualText;
